import { Component } from '@angular/core';

import { AbstractCellComponent } from '@camelot/core';

import { IPrice } from '../../../helpers/price';
import { CamAmountComponent } from '../../amount/amount.component';

@Component({
  host: { 'data-cid': 'grid-billing-amount-cell' },
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '',
  styleUrl: './amount.component.scss',
  templateUrl: './amount.component.html',
  imports: [CamAmountComponent],
})
export class GridBillingAmountCellComponent extends AbstractCellComponent<unknown, IPrice> {}
